import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["buttonText"]

  copy(event) {
    event.preventDefault()

    // Find the password code element
    const codeElement = this.element.querySelector("code")
    const password = codeElement.textContent

    // Copy to clipboard
    navigator.clipboard.writeText(password).then(() => {
      // Update button text temporarily
      const originalText = this.buttonTextTarget.textContent
      this.buttonTextTarget.textContent = "Copied!"

      setTimeout(() => {
        this.buttonTextTarget.textContent = originalText
      }, 2000)
    }).catch(err => {
      console.error("Failed to copy:", err)
      alert("Failed to copy password to clipboard")
    })
  }
}
